import { getEnvVar } from '../../utils/env';

export const createUpgradeLogFileName = (name, version) => {
  const entireName = name.replace(/\s+/g, '');
  return `UpgradeFrom${entireName}${version}.zip`;
};

export const getApplicationManagementUrl = (token) =>
  `${getEnvVar(
    'REACT_APP_ADMIN_APP_URL'
  )}/pages/ApplicationManagementImportHistory.aspx?Token=${token}`;

export const convertLogsToArray = (modules) => {
  if (Array.isArray(modules)) {
    modules.forEach((module) => {
      module.Log = module.Log ?? [];
    });
  } else {
    modules.Log = modules.Log ?? [];
  }

  return modules;
};
